import { history } from 'umi';

//判定是不是移动端
export function isPc() {
  return !/Android|webOS|iPhone|iPod|BlackBerry/i.test(
    window.navigator.userAgent,
  );
}

//空数据删除
export function detArray(array: any) {
  const params = array;
  for (let i in params) {
    const value = params[i];
    if (value === '' || value === null || value === 'null') {
      delete params[i];
    }
  }
  return params;
}

export function download() {
  location.href = '/api/v1/app/download';
}

export function newHistory(route: string) {
  history.push(route, 1);
}

//判定是否包含数字
export function checkNumber(String: string) {
  var reg = /^[0-9]+.?[0-9]*$/;
  if (reg.test(String)) {
    return true;
  }
  return false;
}

//是否包含中文
export function funcChina(String: string) {
  if (/.*[\u4e00-\u9fa5]+.*$/.test(String)) {
    return true;
  }
  return false;
}

export const imgFunc = (value: string) =>
  `http://sama-data-qf.oss-cn-hangzhou.aliyuncs.com/React-html/QiangfenBack/${value}`;

export const questionTypeString = (type: number) => {
  switch (type) {
    case 0:
      return '单选题';
    case 1:
      return '多选题';
    case 2:
      return '分析题';
    case 3:
      return '翻译题';
    case 4:
      return '作文题';
    case 5:
      return '填空题';
    case 6:
      return '计算题';
  }
};

var browser = {
  versions: (function () {
    var u = navigator.userAgent,
      app = navigator.appVersion;
    return {
      //移动终端浏览器版本信息
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
      iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, //是否iPad
      webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
    };
  })(),
  // @ts-ignore
  language: (navigator.browserLanguage || navigator.language).toLowerCase(),
};
export function isBrowser() {
  if (browser.versions.mobile) {
    //判断是否是移动设备打开。browser代码在下面
    var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    // @ts-ignore
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      //在微信中打开
      return 'weixin';
    }
    // @ts-ignore
    if (ua.match(/WeiBo/i) == 'weibo') {
      //在新浪微博客户端打开
      return 'weibo';
    }
    // @ts-ignore
    if (ua.match(/QQ/i) == 'qq') {
      //在QQ空间打开
      return 'qq';
    }
    if (browser.versions.ios) {
      //是否在IOS浏览器打开
      return 'ios';
    }
    if (browser.versions.android) {
      //是否在安卓浏览器打开
      return 'android';
    }
  } else {
    //否则就是PC浏览器打开
    return 'pc';
  }
}

export function getUrlParam(name: string) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); //构造一个含有目标参数的正则表达式对象
  const r = window.location.search.substr(1).match(reg); //匹配目标参数
  if (r != null) return unescape(r[2]);
  return null; //返回参数值
}

export const genRanHex = (size: any) =>
  [...Array(size)]
    .map(() => Math.floor(Math.random() * 16).toString(16))
    .join('');
